/* eslint-disable react/no-unknown-property */
import React from 'react';

import { Box, Grid, Typography } from '@mui/material';
import { NativeTokenOrbital } from 'src/v2/components/ui/images';

import { primaryColors } from '~components/theme/styles/colors';
import { ENativeAsset } from '~config/types';

import SlideWrapper from '../SlideWrapper';

function StablecoinLandingSlide() {
  return (
    <SlideWrapper
      sx={{
        justifyContent: 'center',
        overflow: 'hidden',
        pt: 32,
        pb: 8,
      }}
    >
      <Grid
        container
        direction={{ xs: 'column-reverse', sm: 'row' }}
        justifyContent={'start'}
        textAlign={{ xs: 'center', sm: 'left' }}
        spacing={1}
      >
        <Grid item xs={12} sm={6} mt={{ xs: 12, sm: 0 }}>
          <Typography variant={'h2'} mt={4}>
            Stablecoin Explainer &amp; Features
          </Typography>
          <Typography variant={'body1'} mt={4} mb={8} color={primaryColors[400]}>
            Experience Unparalleled Security & Censorship-Resistance with our overcollateralized stablecoin:
            VST.
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Box display={'flex'} justifyContent={'center'}>
            <NativeTokenOrbital asset={ENativeAsset.VST} />
          </Box>
        </Grid>
      </Grid>
    </SlideWrapper>
  );
}

export default StablecoinLandingSlide;
